import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';

import { convertDraftToPdf } from '@app/features/form';
import { useWorkspaceId } from '@app/hooks/useWorkspaceId';
import { Dispatch } from '@app/store/types';

import { checkContractLinkLimits, contractLinkCreateFileUpload } from '../../actions';
import { MaxActiveLinksError } from '../../convertToContractLinkErrors';

export default function useStartContractLinkByDraft() {
  const dispatch = useDispatch<Dispatch>();
  const workspaceId = useWorkspaceId();

  return useMutation<void, Error, { id: string; title: string }>(async ({ id, title }) => {
    const checkLimitResultAction = await dispatch(checkContractLinkLimits());

    if (checkContractLinkLimits.fulfilled.match(checkLimitResultAction)) {
      const { payload } = checkLimitResultAction;
      if (payload.isLimitExceeded) {
        /**
         * TODO: @Juyeong-Byeon 이슈 논의 후 처리
         * 비즈니스 규칙에 따른 분기를 try catch로 처리하는 부분에 대하여
         * https://github.com/modusign/modusign-client/issues/9103
         *
         */
        throw new MaxActiveLinksError(payload.concurrentActiveLinksLimit, payload.activeLinkCount);
      }

      const convertResultAction = await dispatch(convertDraftToPdf({ workspaceId, draftId: id }));
      if (convertDraftToPdf.rejected.match(convertResultAction)) {
        throw convertResultAction.payload;
      }

      const blob = convertResultAction.payload;

      await dispatch(contractLinkCreateFileUpload({ name: `${title}.pdf`, blob }));
    }

    if (checkContractLinkLimits.rejected.match(checkLimitResultAction)) {
      throw new Error(checkLimitResultAction.error.message);
    }
  });
}
